import { AbstractTenant as AbstractTenant_zoomg } from './AbstractTenant.zoomg';
import { AbstractTenant as AbstractTenant_zoomit } from './AbstractTenant.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_TENANT) {
    case 'zoomg':
      return AbstractTenant_zoomg;

    default:
      return AbstractTenant_zoomit;
  }
};

export const AbstractTenant = IconRenderer();
